export const yeuCauXuatHoaDon = {
  titles: {
    list: '开票申请',
    detail: '开票申请详情',
    create: '创建开票申请',
  },
  sections: {
    list: { title: '开票申请' },
    commentThread: '评论',
    pdfViewer: '发票草稿',
    auditLog: '修改记录',
    buyerInfo: '购买方信息',
    transitionBar: '操作',
    chiTietHangHoa: '商品明细',
    thuKhac: '其他费用',
    tongKetTien: '金额汇总',
    hoaDonChinhThuc: '正式发票',
  },
  form: {
    sectionHeader: '基本信息',
    sectionLines: '开票商品列表',
    nguonTitle: '发票商品明细',
    nguonTabTong: '合计',
    productSearch: '搜索商品编码 / 名称',
    tongSoMatHang: '商品数',
    tongSoLuong: '总数量',
    tongTienHang: '商品金额',
    lineCount: '{count} 行',
    emptyAddProduct: '在上方搜索并选择商品以添加行。',
    emptyAddProductPos: '在绿色搜索栏（F3）输入商品编码 / 名称以添加行。',
    motKhachNhieuHoaDon:
      '一个申请可以包含多张发票（每家公司一张），但只能属于同一客户。一张订单有多个商品编码时，仍可拆到多家公司。',
    hoaDonThuTu: '发票 {index}',
  },
  fields: {
    maYeuCau: '申请编号',
    qr: '二维码',
    hoaDonGoc: '原始发票',
    maHoaDonGoc: '原始发票编号',
    hoaDonNguon: '来源发票',
    khachHang: '客户',
    maKhachHang: '客户编码',
    tenKhachHang: '客户名称',
    nhanVienPhuTrach: '负责销售',
    tenCongTyLayThue: '开票公司名称',
    diaChiLayThue: '开票公司地址',
    soDienThoai: '电话',
    email: '邮箱',
    ghiChu: '备注',
    congTyXuatHd: '开票公司',
    soLuongTuDo: '数量可自由填写，不受原发票明细限制',
    tenNguoiMua: '购买方名称',
    maSoThue: '税号',
    soMatHang: '商品数',
    soTien: '金额',
    diaChiHoaDon: '发票地址',
    tinhThanhHoaDon: '省/市',
    phuongXaHoaDon: '坊/社',
    soCCCD: '身份证号',
    soHoChieu: '护照号',
    emailHoaDon: '发票邮箱',
    soDienThoaiHoaDon: '发票电话',
    nganHang: '开户银行',
    soTaiKhoanNganHang: '银行账号',
    lyDoXuat: '开票原因',
    trangThai: '状态',
    soLanReject: '驳回次数',
    rejectCount: '已驳回 {count} 次',
    createdAt: '创建时间',
    createdBy: '创建人',
    updatedAt: '更新时间',
    updatedBy: '更新人',
    version: '版本',
    uploadedBy: '上传人',
    uploadedAt: '上传时间',
    loaiFile: '文件类型',
    actions: '操作',
    anonymousAuthor: '（匿名）',
    requiredMark: '（必填）',
    optionalMark: '（可选）',
    hintTextBuyerInfo: '3 个必填字段：税号、取税公司名称、取税公司地址。',
    maHangHoa: '商品编码',
    tenHangHoa: '商品名称',
    donViTinh: '单位',
    donViTinhBan: '销售单位',
    donViTinhCoBan: '基本单位',
    soLuong: '数量',
    soLuongBan: '销售数量',
    soLuongCoBan: '基本数量',
    donGia: '单价',
    donGiaBan: '销售单价',
    giamGiaBan: '销售折扣',
    giaBan: '销售价',
    giaBanCoBan: '基本售价',
    thanhTien: '行金额',
    thanhTienBan: '销售金额',
    thanhTienCoBan: '基本金额',
    ngayKhaiVat: '申报日期',
    tenKhaiVat: 'VAT申报名称',
    donViTinhKhaiVat: 'VAT申报单位',
    tyLeBanCoBan: '换算比例',
    tyLeBanCoBanHint: '1个销售单位 = 比例 × 基本单位',
    tyLeBanTrenDvt: '销售单位 / 单位',
    tyLeBanTrenDvtHint: '1个销售单位 = 比例 × 单位',
    tyLeQuyDoi: 'VAT单位 / 销售单位',
    tyLeQuyDoiHint: '1个VAT单位 = 比例 × 销售单位',
    soLuongXuatVat: 'VAT出库数量',
    soLuongXuatVatHint: '按VAT单位录入。默认 = 销售数量 ÷ (VAT单位 / 销售单位)',
    donGiaXuatVat: 'VAT出库单价',
    donGiaXuatVatHint: '按VAT单位录入。默认 = 销售单价 × (VAT单位 / 销售单位)',
    donGiaKhaiVat: 'VAT申报单价(VND)',
    soLuongTonKhaiVat: '剩余数量',
    phanTramVat: '% VAT',
    tenThuKhac: '费用名称',
    giaTri: '金额',
    phanTram: '百分比',
    tongTienHang: '商品总额',
    giamGia: '折扣',
    tongSauGiamGia: '折扣后',
    thuKhac: '其他费用',
    thueGtgt: '增值税',
    khachCanTra: '客户应付',
    khachDaTra: '客户已付',
    tienThua: '找零',
    soHoaDon: '发票号码',
    kyHieuHoaDon: '发票代码',
    ngayXuatHoaDon: '开票日期',
    soHoaDonDaXuat: '已开票 {soHoaDon} · {ngay}',
  },
  filters: {
    maYeuCau: '申请编号',
    maHoaDon: '发票编码',
    soHoaDon: '发票号码',
    maSoThue: '税号',
    maKhachHang: '客户编码',
    tenKhachHang: '客户 / 购买方名称',
    hintSection: '开票申请筛选',
    hintBody: '按状态、时间、申请编号筛选',
    statusSection: '状态',
    dateRangeSection: '创建时间',
    hoaDonGocSection: '原始发票',
    rejectSection: '驳回筛选',
    allStatus: '全部状态',
    daBiReject: '仅显示客户驳回的申请',
    dateRangePlaceholder: '选择日期范围',
    presetHomNay: '今天',
    presetTuanNay: '本周',
    presetThangNay: '本月',
    presetTuyChinh: '自定义',
    resetFilter: '重置筛选',
  },
  placeholders: {
    searchMaYeuCau: '按申请编号搜索...',
    searchQueue: '搜索',
    searchKhachHang: '搜索客户编码 / 名称...',
    inputLyDoXuat: '输入开票原因（例如：为 A 公司开票）',
    chonCongTy: '从客户资料选择',
    chonTaiKhoan: '选择银行账号',
    addHangHoa: '向申请添加商品...',
    writeComment: '写评论...',
    inputLyDoReject: '输入客户不同意原因（可选）',
    inputLyDoHuy: '输入取消原因（可选）',
    hoaDonGocId: '原始发票 UUID',
    tuNgay: '开始日期',
    denNgay: '结束日期',
    kyHieuHoaDon: '例：1C26TAA',
    chonKhaiVat: '— 选择VAT申报行 —',
    chonHangHoa: '点击选择商品',
    doiHangHoaHint: '点击（或回车）选择其他商品',
    chuaCoKhaiVat: '暂无VAT信息',
    khongTimThayHang: '未找到商品',
    khongTimThayKhaiVat: '未找到VAT申报行',
  },
  messages: {
    createAndGuiKtSuccess: '已创建申请 {maYeuCau} 并发送给会计。',
    createButGuiKtFailed: '已创建申请 {maYeuCau}，但未能发送给会计：{reason}',
    listSummary: '共 {count} 个申请',
    createSuccess: '已创建开票申请 {maYeuCau}。',
    yeuCauIntro: '请核对商品、单价及购买方信息。提交后申请将以"新建"状态创建。',
    transitionSuccess: '申请状态已更新。',
    transitionFailed: '无法更新状态。请刷新页面后重试。',
    commentSuccess: '评论已发送。',
    commentEmpty: '请输入评论内容。',
    commentFailed: '无法发送评论，请重试。',
    uploadPdfSuccess: '已上传发票草稿版本 v{n}。',
    uploadPdfFailed: '无法上传草稿文件。请重试。',
    loadDetailFailed: '无法加载申请详情。请稍后重试。',
    loadingDetail: '正在加载申请详情...',
    saving: '保存中...',
    noPermission: '您没有权限执行此操作。',
    noTransition: '此状态下没有可用操作。',
    fileTooLarge: '文件超过 10MB 限制。',
    fileInvalidType: '文件格式无效。仅接受 PDF、JPEG、PNG、Excel（xlsx/xls/csv）。',
    chooseFile: '选择文件或拖放到此处（PDF/JPEG/PNG，最大 10MB）',
    validateBuyerInfoRequired: '请填写全部 3 个必填字段：税号、取税公司名称、取税公司地址。',
    validateLyDoXuatRequired: '请输入开票原因。',
    needLines: '请至少添加一行开票商品。',
    needKhachHang: '请选择客户。',
    khacKhachHang: '所选发票不属于同一客户。一个开票申请只能包含一个客户。',
    needCompany: '每个商品都需要选择开票公司。',
    validateLyDoHuyRequired: '请输入取消原因。',
    updateBuyerSuccess: '已更新购买方信息。',
    updateBuyerFailed: '无法更新购买方信息。',
    updateSuccess: '已更新开票申请 {maYeuCau}。',
    updateFailed: '无法更新开票申请。',
    doiTrangThaiSuccess: '状态已改为“{trangThai}”。',
    xoaFileSuccess: '文件已删除。',
    confirmXoaFile: '删除此发票文件？',
    coThayDoiChuaLuu: '有未保存的修改',
    soSp: '{n} 件',
    chuaCoFile: '暂无文件',
    fileDropHint: '拖放、Ctrl+V 或点击选择文件 · PDF、图片、Excel ≤10MB',
    clipboardKhongCoAnh: '剪贴板中没有图片。请先复制图片再点击粘贴图片。',
    uploadNhapSuccess: '已上传 {n} 个草稿发票文件。',
    dangTaiLen: '正在上传...',
    emptyList: {
      heading: '还没有开票申请',
      body: '当销售人员创建开票申请时，列表将显示在这里。',
    },
    emptyListFiltered: {
      heading: '没有找到符合条件的申请',
      body: '请尝试减少筛选条件或重置以查看全部申请。',
    },
    emptyComments: '还没有评论。留下第一条评论吧。',
    emptyFiles: '还没有上传发票草稿文件。',
    emptyAuditLog: '还没有修改记录。',
    emptyChiTietHangHoa: '还没有商品明细。',
    emptyThuKhac: '还没有其他费用。',
    rowCount: '{count} 行',
    xuatHoaDonSuccess: '申请 {maYeuCau} 已开票。',
    uploadChinhThucSuccess: '已附上正式发票文件。',
    emptyFilesChinhThuc: '尚未附上正式发票文件。',
    vuotTonKhaiVat: '数量超过VAT申报剩余数量',
  },
  actions: {
    taoVaGuiKeToan: '创建并发送给会计',
    create: '创建开票申请',
    send: '提交申请',
    uploadDraft: '上传发票草稿',
    guiKeToan: '发送给财务',
    guiKhach: '发送给客户',
    khachDongY: '客户已同意',
    khachKhongDongY: '客户不同意',
    hoanThanh: '完成',
    huyYeuCau: '取消申请',
    editBuyerInfo: '编辑购方信息',
    saveBuyerInfo: '保存',
    cancelEdit: '取消编辑',
    viewDetail: '查看详情',
    writeComment: '写评论',
    sendComment: '发送评论',
    back: '返回',
    refresh: '刷新',
    addLine: '添加空行',
    xuatHoaDon: '开票',
    xacNhanXuatHoaDon: '确认开票',
    dinhKemHoaDonChinhThuc: '附上正式发票',
    xoaFile: '删除文件',
    hoanTac: '撤销',
    chonFileHd: '选择文件',
    danAnh: '粘贴图片',
    xuatExcelDaChon: '导出已选 Excel',
    capNhatDaXuatHd: '批量标记已开票',
  },
  bulk: {
    exportNeedSelect: '请至少选择一张申请以导出。',
    exportSuccess: '已导出 {count} 张申请的 Excel。',
    exportSheetNguon: '来源发票明细',
    exportSheetXuatVat: '开票明细',
    completeNeedSelect: '请至少选择一张状态为「客户已同意」的申请。',
    completeConfirmTitle: '标记为已开票？',
    completeConfirmBody:
      '将把已选的 {count} 张申请改为「已开票」。已有发票号/符号会保留，之后仍可补填。',
    completeConfirm: '更新',
    completeSuccess: '已更新 {ok}/{total} 张。',
    completePartial: '部分成功：成功 {ok}，失败 {fail}。',
    completeSkip: '已跳过 {count} 张非「客户已同意」状态的申请。',
  },
  aria: {
    back: '返回列表',
    refresh: '刷新详情',
    uploadFile: '上传发票草稿文件',
    sendComment: '发送评论',
    viewDetailRow: '查看申请详情',
    columnPicker: '选择显示列',
    rejectBadge: '客户驳回次数',
    selectAllPage: '选择本页全部行',
    selectRow: '选择行',
  },
  detailTabs: {
    chiTiet: '信息',
    traoDoi: '讨论',
    lichSu: '修改记录',
  },
  expand: {
    rowClickExpand: '点击展开详情',
  },
  confirm: {
    huyYeuCau: {
      title: '取消开票申请？',
      message:
        '此操作无法撤销。申请将被标记为已取消，但所有信息（购买方信息、评论、草稿文件、记录）都会保留以便追溯。',
      confirm: '取消申请',
    },
  },
  trangThai: {
    MOI_TAO: '新建',
    CHO_KT_XU_LY: '待财务处理',
    CHO_KHACH_DUYET: '待客户确认',
    KHACH_DONG_Y: '客户已同意',
    HOAN_THANH: '已开票',
    DA_HUY: '已取消',
  },
  auditActions: {
    CREATE_YCX: '创建请求',
    GUI_KT: '发送财务',
    GUI_KHACH: '发送客户',
    KHACH_DONG_Y: '客户已同意',
    KHACH_KHONG_DONG_Y: '客户不同意',
    HOAN_THANH: '开票',
    HUY: '取消请求',
    UPLOAD_PDF: '上传发票文件',
    CAP_NHAT_YCX: '更新',
    DOI_TRANG_THAI: '更改状态',
  },
  audit: {
    xoaFile: '删除文件',
    trong: '（空）',
  },
  xuatHoaDon: {
    intro: '为每张发票输入电子发票软件中已开具的发票号码（可留空，之后补充）。确认后申请变为“已开票”，仍可修改。',
  },
}
